module.exports = __webpack_public_path__ + "f05afa08117e2fa825cbfde22c47ea78.pdf";